import { render, staticRenderFns } from "./deedItemArticle.vue?vue&type=template&id=38ecce09&scoped=true&"
import script from "./deedItemArticle.vue?vue&type=script&lang=js&"
export * from "./deedItemArticle.vue?vue&type=script&lang=js&"
import style0 from "./deedItemArticle.vue?vue&type=style&index=0&id=38ecce09&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ecce09",
  null
  
)

export default component.exports